import { Products } from 'enums';
import useUserStore from 'stores/user-store';
import type { License } from 'types/licenses.types';

export type LicenseStatus = 'valid' | 'expired' | 'none';

/**
 * Returns the licence status for a given product.
 * 'valid'   – active, non-expired licence exists
 * 'expired' – licence exists but is expired or inactive
 * 'none'    – no licence at all for this product
 */
export const useLicenseStatus = (product: Products): LicenseStatus => {
  const licenses: License[] = useUserStore((s) => s.licenses);

  const match = licenses.find((lic) => lic.product === product);

  if (!match) return 'none';
  if (match.isExpired || !match.isActive) return 'expired';
  return 'valid';
};
